var kennitala = require('./kennitala-b93e0ded.js');

// ---------------------------------------------------------------------------
/**
 * @deprecated Use `isValidKennitala` from `@hugsmidjan/qj/kennitala` instead.
 *
 * (Will be removed in v5)
 */
function validKennitala(
/**
 * A reasonably kennitala-ish string
 *
 * Automatically trims the string and strips away spaces and dashes.
 */
kt, opts) {
    if (opts === void 0) { opts = {}; }
    var cleaner = opts.clean === 'aggressive' ? kennitala.cleanKennitalaAggressive : kennitala.cleanKennitalaCareful;
    kt = kt && cleaner(kt);
    if (!kt) {
        return true;
    }
    var typeMap = {
        einst: 'person',
        fyrirt: 'company',
        '': undefined,
    };
    return kennitala.isValidKennitala(kt, kennitala.__assign(kennitala.__assign({}, opts), { type: typeMap[opts.type || ''] }));
}
validKennitala.clean = kennitala.cleanKennitalaCareful;
validKennitala.cleanAggressive = kennitala.cleanKennitalaAggressive;
validKennitala.format = kennitala.formatKennitala;
validKennitala.getBirthday = kennitala.getKennitalaBirthDate;

module.exports = validKennitala;
